import { es } from '../locales/es_ES';

export const esLang = {
  messages: {
    ...es,
  },
  locale: 'es-ES',
};



// WEBPACK FOOTER //
// ./src/lang/entries/es-ES.js